// src/pages/AccessibilityPage.js
import React from 'react';
import { useEffect } from 'react';
import { Monitor, MousePointer, Keyboard, Eye, Building2, Car, Users } from 'lucide-react';

const AccessibilityPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-center mb-8">הצהרת נגישות והסדרי נגישות</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-6 space-y-8">
        {/* הקדמה */}
        <section>
          <p className="text-gray-600">
            חברתנו נוקטת את מירב המאמצים ומשקיעה משאבים רבים על מנת לספק לכל לקוחותיה שירות שוויוני, מכובד, נגיש ומקצועי. 
            בהתאם לחוק שוויון זכויות לאנשים עם מוגבלויות תשנ"ח-1998 ולתקנות שהותקנו מכוחו, מושקעים מאמצים ומשאבים רבים 
            בביצוע התאמות הנגישות הנדרשות שיביאו לכך שאדם בעל מוגבלות יוכל לקבל את השירותים הניתנים לכלל הלקוחות, 
            באופן עצמאי ושוויוני.
          </p>
        </section>

        {/* הסדרי נגישות מבנים */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Building2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-4">הסדרי נגישות מבנים</h2>
              <p className="text-gray-600 mb-4">
                אנו נמצאים בראול ולנברג 24, תל אביב, מגדלי זיו בניין C.
              </p>
              <p className="text-gray-600 mb-4">להלן הסדרי הנגישות הקיימים במתחם:</p>
              <ul className="space-y-2 text-gray-600">
                <li>• חניות נכים בחניונים 1, 2 ו‑3, בקרבה למעליות</li>
                <li>• רצף גישה מהחניה, דרך הכניסה ועד קבלת השירות—כולל שימוש במעליות</li>
                <li>• שירותי נכים נגישים</li>
                <li>• כניסה מותרת לחיית שירות שנמצאת עם האדם המוגבל</li>
              </ul>
            </div>
          </div>
        </section>

        {/* נגישות אתר האינטרנט */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Monitor className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">נגישות אתר האינטרנט</h2>
              <p className="text-gray-600">
                חברתנו מאמינה ופועלת למען שוויון הזדמנויות במרחב האינטרנטי לבעלי לקויות מגוונות 
                ואנשים הנעזרים בטכנולוגיה מסייעת לשימוש במחשב.
              </p>
            </div>
          </div>
        </section>

        {/* מידע על נגישות האתר */}
        <section className="space-y-4">
          <h2 className="text-xl font-bold mb-4">מידע על נגישות האתר</h2>
          <div className="space-y-3 text-gray-600">
            <p>• אתר זה עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג 2013</p>
            <p>• התאמות הנגישות בוצעו עפ"י המלצות התקן הישראלי (ת"י 5568) לנגישות תכנים באינטרנט ברמת AA ומסמך WCAG2.0 הבינלאומי</p>
            <p>• הבדיקות נבחנו לתאימות הגבוהה ביותר עבור דפדפן כרום</p>
            <p>• האתר מספק מבנה סמנטי עבור טכנולוגיות מסייעות ותמיכה בדפוס השימוש המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה מתפריטים וחלונות</p>
            <p>• מותאם לתצוגה בדפדפנים הנפוצים ולשימוש בטלפון הסלולרי</p>
            <p>• לשם קבלת חווית גלישה מיטבית עם תוכנת הקראת מסך, אנו ממליצים לשימוש בתוכנת NVDA העדכנית ביותר</p>
          </div>
        </section>

        {/* מידע נוסף על נגישות */}
        <section className="space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Eye className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-1" />
              <div className="text-sm text-yellow-800">
                <p className="mb-2">מסמכים או סרטוני וידאו שעלו לאתר לפני אוקטובר 2017 ייתכן שלא נגישים באופן מלא.</p>
                <p>במידה שנתקלתם במסמך כזה או בסרטון, תוכלו לפנות לרכזת נגישות של החברה ואנחנו נדאג להנגיש לכם את המידע.</p>
              </div>
            </div>
          </div>
          
          <div className="space-y-3 text-gray-600">
            <p>• מסירת מידע בפורמט נגיש - החברה מעמידה עבור לקוחותיה אפשרות לקבלת מידע בפורמטים נגישים</p>
            <p>• מסירת המידע הינה ללא עלות ומיועדת עבור אנשים עם מוגבלות</p>
            <p>• לפניות ומידע בנושא נגישות ניתן ליצור קשר עם החברה</p>
          </div>
        </section>

        {/* מאמצים לשיפור */}
        <section className="space-y-4">
          <h2 className="text-xl font-bold mb-4">דרכי פנייה לבקשות והצעות לשיפור בנושא נגישות</h2>
          <p className="text-gray-600 mb-4">
            יש לציין כי אנו ממשיכים במאמצים לשפר את נגישות החברה כחלק ממחויבותנו לאפשר לכלל האוכלוסייה 
            כולל אנשים עם מוגבלויות לקבל את השירות הנגיש ביותר.
          </p>
          <p className="text-gray-600">
            במידה ונתקלת בבעיה או בתקלה כלשהי בנושא הנגישות, נשמח שתעדכן אותנו בכך ואנו נעשה כל מאמץ 
            למצוא עבורך פתרון מתאים ולטפל בתקלה בהקדם ככל שניתן.
          </p>
        </section>

        {/* יצירת קשר לנושאי נגישות */}
        <section className="mt-8 pt-8 border-t">
          <h2 className="text-xl font-bold mb-4">פרטי התקשרות בנושא נגישות</h2>
          <div className="bg-blue-50 rounded-lg p-6">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                <span className="font-medium">טלפון:</span>
                <a href="tel:0545888817" className="text-blue-600 hover:text-blue-800 font-medium">0545888817</a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                <span className="font-medium">דוא"ל:</span>
                <a href="mailto:Office@gemelnet.ai" className="text-blue-600 hover:text-blue-800 font-medium">Office@gemelnet.ai</a>
              </div>
            </div>
          </div>
        </section>

        {/* עדכון אחרון */}
        <section className="mt-8 pt-8 border-t">
          <h2 className="text-xl font-bold mb-4">פרסום הצהרת הנגישות</h2>
          <div className="text-sm text-gray-500">
            הצהרת הנגישות עודכנה ביום: 27/08/2025
          </div>
        </section>
      </div>
    </div>
  );
};

export default AccessibilityPage;